const getWithUpgrade = (products = []) => {
  const withPlan = products.filter(p => p.upgradeUnitPrice && p.upgradeUnitPrice !== 0);
  if (withPlan.length > 0) {
    return true;
  }
  return false;
};

export { getWithUpgrade };
